import { makeStyles, Tooltip } from '@material-ui/core'
import { Close, PowerSettingsNew } from '@material-ui/icons'
import React, { useState, useReducer, useEffect } from 'react'
import {
  useMutation,
  useNotify,
  useRecordContext,
  useRefresh,
  useShowContext,
  useTranslate,
} from 'react-admin'
import { ToggleType } from '../../../../core/devices/passages/passage-set-boolean-status-button'
import { PassageDto } from '../../../../core/dto/device/passages/passage.dto'
import { PassageSelectStateDialog } from '../PassageDialogs'
import {
  passageSetPowerButtonInitialState,
  passageSetPowerButtonReducer,
} from '../../../../core/devices/passages/passage-set-power-button.reducer'
import { useHasAuthority } from '../../../hooks/useHasAuthority'
import { Authority } from '../../../../core/auth/Authority'

const useStyles = makeStyles({
  iconContainer: {
    position: 'relative',
    width: 34,
  },
  icon: {
    position: 'absolute',
    left: 5,
    top: 5,
    fontSize: '24px !important',
  },
  crossIcon: {
    position: 'absolute',
    left: 0,
    top: 0,
    fontSize: 34,
    opacity: 0.8,
  },
})

export const PassageSetPowerCompactButton = ({ ...props }) => {
  const { disabled, PowerTurnedOn } = props
  const notify = useNotify()
  const { loading } = useShowContext()
  const translate = useTranslate()
  const classes = useStyles()
  const hasAuthority = useHasAuthority()

  const [{ mutateQuery }, dispatch] = useReducer(
    passageSetPowerButtonReducer,
    passageSetPowerButtonInitialState,
  )
  const [dialogOpen, setDialogOpen] = useState(false)
  const [state, setState] = useState(false)
  const passage = useRecordContext<PassageDto>()
  const [mutate, { loading: mutationLoading }] = useMutation()
  const refresh = useRefresh()

  useEffect(() => {
    if (state) {
      dispatch({ type: ToggleType.OFF })
    } else {
      dispatch({ type: ToggleType.ON })
    }
  }, [state])

  const handlePower = async (
    recurringJobName?: string,
    cronExpression?: string,
    auditNote?: string,
  ) => {
    const query = mutateQuery?.(passage, auditNote)
    await mutate(query, {
      returnPromise: true,
      onFailure: (err) => notify(err?.message, 'error'),
    })
    refresh()
  }

  return (
    <>
      <PassageSelectStateDialog
        open={dialogOpen}
        confirm={handlePower}
        method="powerState"
        close={() => setDialogOpen(false)}
        state={state}
        setState={setState}
        OnIcon={<PowerSettingsNew className={classes.icon} />}
        OffIcon={
          <>
            <PowerSettingsNew className={classes.icon} />
            <Close fontSize="large" className={classes.crossIcon} />
          </>
        }
        withAuditNote
      />
      <Tooltip
        title={translate('resources.modules.fields.powerState')}
        onClick={
          !loading &&
          !mutationLoading &&
          !disabled &&
          hasAuthority(Authority.PASSAGES_SET_POWER_BUTTON)
            ? () => setDialogOpen(true)
            : undefined
        }
      >
        <div
          className={classes.iconContainer}
          style={{
            cursor:
              !loading &&
              !mutationLoading &&
              !disabled &&
              hasAuthority(Authority.PASSAGES_SET_POWER_BUTTON)
                ? 'pointer'
                : 'default',
          }}
        >
          <PowerSettingsNew className={classes.icon} />
          {!PowerTurnedOn ? (
            <Close fontSize="large" className={classes.crossIcon} />
          ) : undefined}
        </div>
      </Tooltip>
    </>
  )
}
